exports = module.exports = require("../../../../css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "svg.timeslider{opacity:.8;border:1px solid #000;height:6em;box-shadow:3px 3px 3px rgba(0,0,0,.39);font:400 12px Arial}.timeslider{cursor:ew-resize}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// /~/css-loader!/~/postcss-loader!/~/eoxc/src/core/views/TimeSliderView.css
// module id = 1974
// module chunks = 0